'use strict';

var util = require('../util'),
	ajax = require('../ajax'),
	dialog = require('../dialog');
/**
 * @function
 * @description switch between hotel chocolat and testing club order history list
 */
function initializeEvents () {
	$('.orderhistory-wrapper').on('touchstart click', '.tab', function (e) {
		var classN; //associated container className of a clicked tab
		e.preventDefault();
		if (util.viewport.isMobile()) {
			$(this).toggleClass('active');
			classN = $(this).hasClass('hotelchocolat') ? '.hotelchocolat-orderhistory' : '.subscriptions-orderhistory';
			if ($(this).hasClass('active')) {
				$(classN).addClass('active');
			} else {
				$(classN).removeClass('active');
			}
		} else {
			if ($(this).hasClass('active')) {
				return;
			} else {
				$('.tab', '.orderhistory-form').removeClass('active');
				$(this).addClass('active');
				if ($(this).hasClass('hotelchocolat')) {
					$('.subscriptions-orderhistory').removeClass('active');
					$('.hotelchocolat-orderhistory').addClass('active');
				} else if ($(this).hasClass('subscriptions')) {
					$('.subscriptions-orderhistory').addClass('active');
					$('.hotelchocolat-orderhistory').removeClass('active');
				}
			}
		}
	}).on('touchstart click', '.load_more', function (e) {
		var orders = $(this).closest('.orderhistory-form').find('.order-item');
		e.preventDefault();
		orders.filter(':hidden:lt(5)').css('display', 'block');
		if (orders.filter(':hidden').length === 0) {
			$(this).css('display', 'none');
		}
	}).on('click', '.order-status-info-dialog', function () {
		var html = $(this).find('.dialog-html').clone();
		var title = $(this).siblings('.label').html().slice(0, -1);

		dialogOpen(html, title);
	}).on('click', '.product-availability-info-dialog', function () {
		var $item = $(this).parents('.product-item');
		var itemName = $item.find('.item-details .name').text();
		var html = $('.orderhistory-wrapper .product-unavailable-info').first().clone();
		html.find('.detail .name').html(itemName);
		var title = 'SORRY!';

		dialogOpen(html, title);
	});

	$('.load_more-orders').on('click', function (e) {
		e.preventDefault();
		var ordersWrapper = $(this).closest('.hotelchocolat-orderhistory');
		var orders = ordersWrapper.find('.order-item');
		var start = orders.length;
		var ajaxSubmitted = true;
		var renderedOrdersNumber = $('input[name=ordersNumber]').val();
		var url = util.appendParamsToUrl(Urls.loadMoreOrders, {
			start: start,
			ajax: ajaxSubmitted
		});
		ajax.load({
			url: url,
			callback: function (response) {
				orders.last().after(response);
				if (renderedOrdersNumber === $('.order-item').length) {
					$('.load_more-orders').css('display', 'none');
					ordersWrapper.find('.order-item').last().css('margin', '0');
				}
			}
		});

	});
	$('#account-nav-container').find('a:contains("ORDER HISTORY")').parent().addClass('active');
}

function dialogOpen(content, title) {
    dialog.open({
        html: content,
        options: {
            dialogClass: 'oh-dialog',
            open: function () {},
            buttons: [
                {
                    text: Resources.CLOSE,
                    class: 'btn-close',
                    click: function () {
                        dialog.close();
                    }
                }
            ],
            title: title
        }
    });
}


exports.init = function () {
	$(window).smartresize(function () {
		var tabs = $('.orderhistory-form .tab');
		if (!util.viewport.isMobile()) {
			if (tabs.filter('.active').length > 1) {
				tabs.last().removeClass('active');
				$('.subscriptions-orderhistory').removeClass('active');
			}
		}
	});
	$('.orderhistory-form').each(function () {
		if ($(this).find('.order-item').length > 5) {
			$(this).find('.load_more').show();
		}
	});
	initializeEvents();
};
